import React from 'react';
import { Button, Box, Stack, Typography } from '@mui/material';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useMutation } from 'react-fetching-library';
import { DebounceInput } from 'react-debounce-input';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

import { SmallFormTextField } from '../../../../../components/small-fields/SmallFormTextField';
import { AlertDialogContainer } from '../../../../../components/others/AlertDialogContainer';
import { submitAccomodationAction } from '../../../../../services/request';
import { ConfirmDialog } from '../../../../../components/ConfirmDialog';
import { useSelector } from 'react-redux';

export const AccomodationForm = props => {
  const { data, submitCallback, handleClose, allResorts, allSeasons } = props;
  const { module, seasonYear } = useSelector(state => state.app);
  const { loading, mutate } = useMutation(submitAccomodationAction);
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [confirmDeleteOpen, setConfirmDeleteOpen] = React.useState(false);

  const validationSchema = Yup.object({
    name: Yup.string().required('To pole nie może być puste')
  });

  const initialValues = {
    name: data ? data.name || '' : '',
    resorts: data ? data.resorts : [],
    seasons: data ? data.seasons : [],
    gross_value_per_day: data ? data.gross_value_per_day : 0,
    slots_count: data ? data.slots_count : 0
  };

  const handleSubmit = async values => {
    const { error, payload } = await mutate(values, data ? 'PUT' : 'POST', data ? data.id : undefined);
    if (!error) {
      submitCallback(payload, data ? 'edit' : 'created', 'success', data ? 'Zaktualizowano zakwaterowanie' : 'Dodano nowe zakwaterowanie', '');
      handleClose();
    } else {
      setSeverity('error');
      setTitle('Nie udało się dodać nowego zakwaterowania');
      setMessage('');
      setShowAlert(true);
    }
  };

  const handleDelete = async () => {
    const { error, payload } = await mutate([], 'DELETE', data.id);
    if (!error) {
      submitCallback(data, 'delete', 'success', `Usunięto zakwaterowanie ${data.name}`, '');
      handleClose();
    } else {
      setSeverity('error');
      setTitle(`Nie udało się usunąć zakwaterowania ${data.name}`);
      setMessage(payload);
      setShowAlert(true);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
    onSubmit: values => {
      handleSubmit(values);
    }
  });

  return (
    <>
      {showAlert && (
        <AlertDialogContainer
          severity={severity}
          title={title}
          message={message}
          setShowAlert={setShowAlert}
        />
      )}
      <form onSubmit={formik.handleSubmit} style={{ textAlign: 'center' }}>
        <Box display="flex" flexDirection="column" mt={1} p={1} ml="5%" mr="5%">
          <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
            <Typography variant="subtitle2" flex="1 1 10%">Nazwa</Typography>
            <DebounceInput
              sx={{ flex: '1 1 90%' }}
              name="name"
              id="name"
              type="text"
              placeholder="nazwa zakwaterowania"
              value={formik.values.name}
              onChange={formik.handleChange}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
              debounceTimeout={100}
              element={SmallFormTextField}
              autoFocus
            />
          </Stack>
          <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
            <Typography variant="subtitle2" flex="1 1 10%">Ośrodki</Typography>
            <SmallFormTextField
              sx={{ flex: '1 1 90%' }}
              select
              multiple
              id="resorts"
              name="resorts"
              options={allResorts}
              value={formik.values.resorts}
              onChange={formik.handleChange} />
          </Stack>
          <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
            <Typography variant="subtitle2" flex="1 1 10%">Sezony</Typography>
            <SmallFormTextField
              sx={{ flex: '1 1 90%' }}
              select
              multiple
              id="seasons"
              name="seasons"
              options={allSeasons}
              value={formik.values.seasons}
              onChange={formik.handleChange} />
          </Stack>
          {module == 'wyjazdy_rodzinne' && seasonYear == 2025 && <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
            <Typography variant="subtitle2" flex="1 1 10%">Wartość (zł) za 1 dobę</Typography>
            <DebounceInput
              sx={{ flex: '1 1 90%' }}
              name="gross_value_per_day"
              id="gross_value_per_day"
              type="text"
              placeholder="wartość"
              value={formik.values.gross_value_per_day}
              onChange={formik.handleChange}
              error={formik.touched.gross_value_per_day && Boolean(formik.errors.gross_value_per_day)}
              helperText={formik.touched.gross_value_per_day && formik.errors.gross_value_per_day}
              debounceTimeout={300}
              element={SmallFormTextField}
              autoFocus
            />
          </Stack>}
          {module == 'wyjazdy_rodzinne' && <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
            <Typography variant="subtitle2" flex="1 1 10%">Ilość miejsc</Typography>
            <DebounceInput
              sx={{ flex: '1 1 90%' }}
              name="slots_count"
              id="slots_count"
              type="text"
              placeholder="wartość"
              value={formik.values.slots_count}
              onChange={formik.handleChange}
              error={formik.touched.slots_count && Boolean(formik.errors.slots_count)}
              helperText={formik.touched.slots_count && formik.errors.slots_count}
              debounceTimeout={300}
              element={SmallFormTextField}
              autoFocus
            />
          </Stack>}
        </Box>
        <Button
          color="primary"
          variant="contained"
          type="submit"
          sx={{ mt: 3 }}
          disabled={loading}
        >
          <AddIcon />
          Zapisz
        </Button>
        { data
          ? <Button
            color="error"
            variant="contained"
            sx={{ mt: 3, ml: 4 }}
            onClick={() => {
              setConfirmDeleteOpen(true);
            }}
            disabled={loading}
          >
            <DeleteIcon />
          Usuń
          </Button>
          : null}
      </form>
      <ConfirmDialog
        title="Usunąć Zakwaterowanie?"
        open={confirmDeleteOpen}
        setOpen={setConfirmDeleteOpen}
        onConfirm={handleDelete}
      >
        Czy na pewno chcesz usunąć te zakwaterowanie?
      </ConfirmDialog>
    </>

  );
};
